import {Injectable} from '@angular/core';
import {ReportComponentModel} from "../../../api/entity/reportComponent.model";
import {ReportComponentDataService} from "./reportComponentData.service";
import {AbstractDataServiceDtoSummaryAdapter} from "../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter";
import {ReportComponentSummaryModel} from "../../../api/entity/reportComponentSummary.model";
import {ReportComponentSummaryConverter} from "../../../api/entity/converter/reportComponentSummary.converter";

@Injectable()
export class ReportComponentSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<ReportComponentSummaryModel, ReportComponentSummaryConverter, ReportComponentModel> {
    constructor(dataService: ReportComponentDataService, converter: ReportComponentSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ReportComponentModel {
        return new ReportComponentModel();
    }


}
